import { render, staticRenderFns } from "./MSA.vue?vue&type=template&id=25e449f2&"
import script from "./MSA.vue?vue&type=script&lang=js&"
export * from "./MSA.vue?vue&type=script&lang=js&"
import style0 from "./MSA.vue?vue&type=style&index=0&id=25e449f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports